const layout = () => import(/* webpackChunkName: "layout" */ '@/components/layout');

export default [
  {
    path: '',
    component: layout,
    children: [
      {
        name: 'store',
        component: () => import(/* webpackChunkName: "b2b_store" */ '@/pages/store'),
        meta: {
          title: '店铺'
        },
        path: '/store/:id',
        children: [
          {
            name: 'storeHomePage',
            component: () => import(/* webpackChunkName: "b2b_store_homePage" */ '@/pages/store/homePage'),
            meta: {
              title: '店铺首页'
            },
            path: 'homePage'
          },
          {
            name: 'allGoods',
            component: () => import(/* webpackChunkName: "b2b_store_allGoods" */ '@/pages/store/allGoods'),
            meta: {
              title: '全部商品'
            },
            path: 'goods'
          },
          {
            name: 'qualifications',
            component: () => import(/* webpackChunkName: "b2b_store_qualifications" */ '@/pages/store/qualifications'),
            meta: {
              title: '资质配送'
            },
            path: 'qualifications'
          }
        ]
      }
    ]
  }
];
